//
//
//
//
//
//
//
//
//

// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2023 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
import { copyrightInfoApi } from '@/api/authInformation';
import { checkPermi } from '@/utils/permission'; // 权限判断函数
export default {
  name: 'i-copyright',
  data: function data() {
    return {
      links: [{
        title: '官网',
        key: '1',
        href: 'https://www.baidu.com',
        blankTarget: true
      }, {
        title: '社区',
        key: '2',
        href: 'https://www.baidu.com',
        blankTarget: true
      }, {
        title: '文档',
        key: '3',
        href: 'https://www.baidu.com',
        blankTarget: true
      }],
      copyright: 'Copyright © 2023 北京三酷科技有限公司',
      copyrightNew: ''
    };
  },
  mounted: function mounted() {
    if (checkPermi(['platform:copyright:get:info'])) this.getVersion();
  },
  methods: {
    getVersion: function getVersion() {
      var _this = this;
      copyrightInfoApi().then(function (res) {
        var data = res || {};
        _this.copyrightNew = data.companyName ? data.companyName : _this.copyright;
      });
    }
  }
};